import Delete from "@mui/icons-material/Delete";
import Grid2 from "@mui/material/Grid2";
import IconButton from "@mui/material/IconButton";
import React from "react";
import { useFormContext } from "react-hook-form";
import FormTextField from "../../Common/FormTextField";
import { getFieldPath } from "../../Common/SchemaUtils";

const StringFormFields: React.FC<{
  extractionId: string;
  extractionPath?: string;
  label?: string;
  remove?: Function;
}> = ({ extractionId, extractionPath, label, remove }) => {
  const { control } = useFormContext();
  return (
    <Grid2 container spacing={2} sx={{ alignItems: "center" }}>
      <Grid2 size={remove !== undefined ? 11 : 12}>
        <FormTextField
          size="small"
          label={label}
          name={`extraction.${getFieldPath([
            extractionId,
            "value",
            extractionPath,
          ])}`}
          control={control}
        />
      </Grid2>
      {remove !== undefined && (
        <Grid2 size={1} sx={{ textAlign: "right" }}>
          <IconButton
            onClick={() => {
              remove();
            }}
            className="rounded-full"
            size="small"
          >
            <Delete color="error" />
          </IconButton>
        </Grid2>
      )}
    </Grid2>
  );
};

export default StringFormFields;
